export const DATASET_OPTIONS = [
  { id: 'subsurface_with_grid', name: 'Subsurface inc Grid' },
  { id: 'subsurface_no_grid', name: 'Subsurface no Grid' },
  { id: 'ccs_projects', name: 'CCS Projects' },
  { id: 'emissions', name: 'Emissions' },
  { id: 'infrastructure', name: 'Infrastructure' },
  { id: 'blocks', name: 'Blocks' },
  { id: 'licences', name: 'Licences' },
  { id: 'windfarms', name: 'Windfarms' }
];

export const MODULE_OPTIONS = [
  { id: 'ccs_module', name: 'CCS Module' },
  { id: 'analogue_finder', name: 'Analogue Finder' }
];

// Legacy mapping for backward compatibility
export const LEGACY_LICENSE_MAPPING = {
  viewDatabase: ['subsurface_with_grid', 'subsurface_no_grid', 'infrastructure', 'blocks', 'licences'],
  ccsModule: ['ccs_module'],
  viewAnalogue: ['analogue_finder']
};

// Dataset ID mapping to original system IDs for API compatibility
export const DATASET_ID_MAPPING = {
  'subsurface_with_grid': [1], // Subsurface Assets with grids
  'subsurface_no_grid': [1], // Subsurface Assets without grids
  'ccs_projects': [8], // CCS Projects
  'emissions': [4], // CO2 Emitters
  'infrastructure': [2], // Infrastructure Assets
  'blocks': [32], // Blocks
  'licences': [64], // Licences
  'windfarms': [128] // Windfarms
}; 